import downloadFromApi from "utils/download-from-api";
import { ApiActions } from "middleware/call-api";
import { ActionTypes } from "../reducers/reportExport.reducers";
import { showMessage } from "../../../store/actions";

export const addExportJobList = exportJobList => ({
  type: ActionTypes.ADD_EXPORT_JOB_LIST,
  payload: exportJobList,
});

export const getExportJobList = orgUnitId => async dispatch => {
  const url = `/reportExport/${orgUnitId}/getAll`;

  return dispatch({
    [ApiActions.FETCH_FROM_API]: {
      endpoint: url,
      method: "GET",
      entityType: "EXPORT_JOB_LIST",
    },
  });
};

export const downloadExportedReport = async (orgUnitId, exportId) => {
  const url = `api/reportExport/${orgUnitId}/${exportId}/download`;

  const response = await downloadFromApi(url);

  return response.statusText;
};

export const addPendingExport = exportId => ({
  type: ActionTypes.ADD_PENDING_EXPORT,
  payload: exportId,
});

export const removePendingExport = exportId => ({
  type: ActionTypes.REMOVE_PENDING_EXPORT,
  payload: exportId,
});

export const showExportIndicator = () => ({
  type: ActionTypes.SHOW_EXPORT_INDICATOR,
});

/**
 * Common handler for export responses
 * @param {Promise} responsePromise - Promise returning the API response
 * @param {Dispatch<any>} dispatch - Redux dispatch function
 * @returns {Promise<Object|null>} The parsed response data or null if error
 */
export const handleHangfireExportResponse = async (responsePromise, dispatch) => {
  try {
    const response = await responsePromise;

    if (!response.ok) {
      const errorMessage = await response.text();
      dispatch(showMessage({ message: errorMessage, variant: "error" }));
      return null;
    }

    const data = await response.json();

    if (data.exportId) { // For background exports, show indicator and save exportId
      dispatch(showExportIndicator());
      dispatch(addPendingExport(data.exportId));
    }

    return data;
  } catch (error) {
    dispatch(showMessage({
      message: error.message || "An error occurred during hangfire export",
      variant: "error",
    }));
    return null;
  }
};

export const removeExportCompleteIndicator = () => ({
  type: ActionTypes.REMOVE_EXPORT_COMPLETE_INDICATOR,
});

export const clearExportCompleteJob = () => ({
  type: ActionTypes.CLEAR_EXPORT_COMPLETE_JOB,
});

export const clearExportedReport = (orgUnitId, exportId) => async dispatch => {
  const url = `/reportExport/${orgUnitId}/clear/${exportId}`;

  return dispatch({
    [ApiActions.DELETE_FROM_API]: {
      endpoint: url,
      entityType: "EXPORT_JOB",
      exportId,
    },
  });
};
